export default __webpack_public_path__ + "static/media/rain-night.b5a7ac13.svg";